import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./RequestQuote.css";
import RAQBG from "../../Assets/request_a_quote_banner.webp";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";
import api ,{ PUBLIC_BASE_URL } from "../../api/api";

const RequestQuote = () => {
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const [selectedOption, setSelectedOption] = useState("");
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    description: "",
    products: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaValue) {
      Swal.fire({
        icon: "warning",
        title: "CAPTCHA not completed!",
        text: "Please complete the CAPTCHA before submitting.",
      });
      return;
    }
    setLoading(true);
    try {
      const res = await api.post("/request-a-quote", formData);
      // SweetAlert success popup
      Swal.fire({
        title: "Success!",
        text: "Submitted successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        description: "",
        products: "",
      });
    } catch (err) {
      // SweetAlert error popup
      Swal.fire({
        title: "Error!",
        text: "Submission failed. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });

      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const [bannerData, setBannerData] = useState(null);

  useEffect(() => {

    api.get('/requestquotebanner')
      .then((response) => {
        // console.log("Banner Data:", response.data);
        if (response.data && response.data.length > 0) {
          setBannerData(response.data[0]); // Access the first banner data
        }
      })
      .catch((error) => console.error("Error fetching request a quote banner:", error));
  }, []);


  if (!bannerData) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Header />

      {/* banner section start  */}
      <section
      className="container-fluid common_banner"
      style={{
        backgroundImage: `url(${PUBLIC_BASE_URL}${bannerData.image})`, // Dynamic background image
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="common_title wow fadeInUp">
              <h1>{bannerData ? bannerData.title : "Loading..."}</h1> {/* Dynamic title */}
            </div>
          </div>
        </div>
      </div>
    </section>
      {/* banner section end */}

      {/* request form section start  */}
      <section className="container-fluid request_form_section" style={{ backgroundColor: '#f9f9f9', padding: '40px 0' }}>
  <div className="container mb-5">
    <div className="row">
      <div className="col-lg-6 col-md-6 col-sm-12 mt-5" style={{ paddingRight: '30px' }}>
        <div className="common_title fadeInUp" style={{ marginBottom: '20px' }}>
          <h2 style={{ color: '#317ac7', fontSize: '2.5rem', fontWeight: '700', fontFamily: 'Inter, sans-serif', marginBottom: '10px' }}>Request A Quote</h2>
          <p style={{ color: '#444', lineHeight: '1.6', marginTop: "30px", fontSize: '17px', fontWeight: '400', textAlign: 'justify' }}>
            Get in touch with us for a customized quote. Fill out the form, and our team will provide the best solution for your needs.
          </p>
        </div>
        <div style={{ marginTop: '30px', color: '#555' }}>
          <h3 style={{ fontSize: '1.8rem', color: '#317ac7', fontWeight: '600' }}>Our Expertise</h3>
          <p style={{ color: '#444', fontSize: '16px', fontWeight: '400', lineHeight: '1.8', marginTop: '20px' }}>
            At Khodiyar Industries, we specialize in premium automotive and commercial vehicle glass, including toughened and laminated glass. Our products are designed for durability, scratch resistance, and precision, ensuring optimal performance for your needs.
          </p>
          <p style={{ color: '#444', fontSize: '16px', fontWeight: '400', lineHeight: '1.8', marginTop: '20px' }}>
            With state-of-the-art manufacturing and a commitment to quality, we offer customized glass solutions at competitive prices to meet the diverse needs of our clients.
          </p>
        </div>
      </div>

      <div className="col-lg-6 col-md-6 col-sm-12">
        <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
          <form action="action_form fadeInUp" onSubmit={handleSubmit}>
            <div className="row mt-5">
              <div className="col-lg-6 col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form_text">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="First Name"
                    required=""
                    name="firstname"
                    value={formData.firstname}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444' }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form_text">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Last Name"
                    required=""
                    name="lastname"
                    value={formData.lastname}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444' }}
                  />
                </div>
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form_text">
                  <input
                    className="form-control"
                    type="email"
                    placeholder="Email"
                    required=""
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444' }}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form_text">
                  <input
                    className="form-control"
                    type="tel"
                    placeholder="Phone"
                    required=""
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444' }}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form-floating form_text">
                  <textarea
                    className="form-control"
                    type="text"
                    placeholder="Describe your requirements"
                    style={{ height: "136px", width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444', fontFamily: 'Nunito, sans-serif' }}
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>
              <div className="col-lg-12 col-sm-12 col-md-12" style={{ marginBottom: '20px' }}>
                <select
                  className="form-select"
                  name="products"
                  value={formData.products}
                  onChange={handleChange}
                  style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444', fontFamily: 'Nunito, sans-serif' }}
                >
                  <option value={selectedOption} style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Select a product</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Window Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Car Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>E Rickshaw Glass</option>
                  {/* <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Automotive Glass</option> */}
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Commercial Vehicle Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Automotive Toughened Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Road & Construction Equipment Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Automotive Laminated Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Arctitecture Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Home Appliance & General Street glasses</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Railway Window Glass</option>
                  <option value="Tinted Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>DGU Glass</option>
                </select>
              </div>
              <div className="col-lg-12 col-sm-12 col-md-12" style={{ marginBottom: '20px' }}>
                <div className="captcha-box">
                  <div className="recaptcha-logo">
                    <ReCAPTCHA
                      sitekey="6LeUIessAAAAAEiEJZ3-i--wUUDacFTxNmXQxdSN"
                      onChange={handleCaptchaChange}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-sm-12 col-md-12">
                <div
                  className="submit_btn"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end", // Align button to the right
                    alignItems: "center",
                  }}
                >
                  <button
                    type="submit"
                    disabled={loading}
                    style={{ backgroundColor: '#8067f0', color: '#fff', padding: '12px 25px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '1rem', fontFamily: 'Inter, sans-serif', fontWeight: '700' }}
                  >
                    {loading ? "Submitting..." : "Request Quote"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>


      {/* form_section end */}
      <Footer />
    </div>
  );
};

export default RequestQuote;
